module.exports = __webpack_public_path__ + "static/img/manual_zh_26.6e954a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_26.png
// module id = ee2j
// module chunks = 4